import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { TotalCount } from '../search.interface';
import { FILTER_SECTION } from '../search.component';

@Component({
  selector: 'ft-search-results-general',
  templateUrl: './search-results-general.component.html',
  styleUrls: ['./search-results-general.component.scss'],
})
export class SearchResultsGeneralComponent implements OnInit {
  @Input() results: [];
  @Input() totalCount: TotalCount["advisor"];
  @Input() valueToShow: number;
  queryParams: Params;
  @Input() isViewAll: boolean;
  @Output()
  viewAllClick: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  loadMoreGeneral: EventEmitter<object> = new EventEmitter<object>();

  clickEvent(event): void {
    this.isViewAll = true;
    this.viewAllClick.emit(FILTER_SECTION.generalFilterSection);
  }

  loadMore(event): void {
    this.loadMoreGeneral.emit({ event, type: 'pages' });
  }

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.queryParams = this.activatedRoute.snapshot.queryParams;
  }
}
